import { Alert as MuiAlert, AlertTitle as MuiAlertTitle } from '@mui/material'
import { node, string } from 'prop-types'
import XIcon from '../../atoms/icons/x-icon'
import { AlertStyled, Message } from './notification.styled'

const Notification = ({ action, message, onClose, title, ...props }) => (
	<AlertStyled
		action={
			<>
				{action}
				{onClose && <XIcon onClick={() => onClose()} />}
			</>
		}
		title={title}
		{...props}
	>
		{title && <MuiAlertTitle>{title}</MuiAlertTitle>}
		{message && <Message>{message}</Message>}
	</AlertStyled>
)

Notification.propTypes = {
	...MuiAlert.propTypes,
	/**
	 * The message to display
	 */
	message: node,
	/**
	 * The title to display
	 */
	title: string,
}

export default Notification
